import css from '../../../../../utils/css';

const styles = css`
  *[class^='Theme_'] {
    --primary-font-family: 'Inter', sans-serif;
    --primary-font-family-condensed: 'Inter', sans-serif;
    --secondary-font-family: 'Inter', sans-serif;

    --font-family: sans-serif;

    --primary-color: #e53c2e;

    --offer-cta-bg-color-hover: #e53c2ecc;
    --offer-cta-color: #fff;
  }

  *[class^='Text_'] {
    font-family: var(--secondary-font-family);
  }

  *[class^='Cta_'] > button {
    font-family: var(--primary-font-family-condensed);
  }
`;

export default styles;
